module.exports = __webpack_public_path__ + "img/mercedes-amg-model-car.5cf1fa51.jpg";